import Text from '../text/Text'
import React, { useState } from 'react'
import SvgIcon from '../svgIcon/SvgIcon'
import { DrawerStyles } from './DrawerStyles'
import storeBtn from '../../assets/icons/change-store-drawer-btn.png'
import { getLocalName, isAdmin, isLocalView } from '../../Utils/Profile'
import amipossWhite from '../../assets/icons/amipos-drawer-white.png'
import styles from './drawer.module.css'

interface MenuDrawerItemProperties {
    title: string
    icon: IconName | JSX.Element
    rightIcon?: IconName | JSX.Element
    onClick?: () => void
    onClickEvent?: (navegate: boolean) => void
    menu?: MenuDrawerItemProperties[]
    hide?: boolean
}

interface MenuDrawerSectionProperties {
    sectionName: string
    onNavigate?: () => void
    collapse?: string | undefined
    menu: MenuDrawerItemProperties[]
    onCollapse?: (sectionName: string, onNavigate?: () => void) => void
    onClickEvent?: (navegate: boolean) => void
    hide?: boolean
    highlight?: boolean
    preText?: JSX.Element
}

function RenderItem(properties: MenuDrawerSectionProperties) {
    const RenderChildren = ({
        menu,
        deep = 0,
    }: {
        menu: MenuDrawerItemProperties[]
        deep?: number
    }) => {
        const [collapse, setCollapse] = useState<{ [key: string]: boolean }>()

        if (menu.length === 0) return null

        const handlerClickItem: (
            onClick?: () => void,
            item?: string,
            onClickEvent?: (event: boolean) => void
        ) => void = (onClick, item, onClickEvent) => {
            if (onClickEvent) {
                onClickEvent(true)
            }

            if (onClick) {
                return onClick()
            }

            if (menu.length > 0 && item) {
                return setCollapse((old) => ({
                    ...old,
                    [item]: old && old[item] ? !old[item] : true,
                }))
            }
        }

        return (
            <>
                {menu
                    .filter((item) => !item.hide)
                    .map((i, index) => (
                        <div key={index} style={{ marginLeft: deep * 25 }}>
                            <button
                                onClick={() =>
                                    handlerClickItem(
                                        i.onClick,
                                        i.title,
                                        i.onClickEvent
                                    )
                                }
                                style={DrawerStyles.sectionItemBtn}
                            >
                                <div style={DrawerStyles.sectionItemBtnContent}>
                                    {typeof i.icon === 'string' ? (
                                        <SvgIcon
                                            iconName={i.icon}
                                            width={22}
                                            height={22}
                                        />
                                    ) : (
                                        i.icon
                                    )}
                                    <Text
                                        fontSize={14}
                                        marginLeft={5}
                                        label={i.title}
                                        color="#656565"
                                        fontWeight={400}
                                        textAlign="start"
                                    />
                                    {typeof i.rightIcon === 'string' ? (
                                        <SvgIcon
                                            iconName={i.rightIcon}
                                            width={22}
                                            height={22}
                                        />
                                    ) : (
                                        i.rightIcon
                                    )}
                                </div>
                                {i.menu && i.menu.length > 0 && (
                                    <div
                                        style={{
                                            transform:
                                                collapse && collapse[i.title]
                                                    ? 'rotate(90deg)'
                                                    : '',
                                        }}
                                    >
                                        <SvgIcon
                                            width={12}
                                            height={12}
                                            iconName="IconRight"
                                        />
                                    </div>
                                )}
                            </button>
                            {i.menu && collapse && collapse[i.title] ? (
                                <div>
                                    <RenderChildren
                                        menu={i.menu}
                                        deep={deep + 1}
                                    />
                                </div>
                            ) : null}
                        </div>
                    ))}
            </>
        )
    }

    return (
        <div style={DrawerStyles.container}>
            <button
                style={DrawerStyles.sectionItem}
                className={`
                    ${properties.highlight ? styles.highlight : ''} 
                    ${properties.preText ? styles.preText : ''} 
                    `}
                onClick={() => {
                    if (properties.onClickEvent) {
                        properties.onClickEvent(true)
                    }

                    properties.onCollapse &&
                        properties.onCollapse(
                            properties.sectionName,
                            properties.onNavigate
                        )
                }}
            >
                {properties.preText}
                <Text
                    color={properties.highlight ? '#fff' : '#656565'}
                    label={properties.sectionName}
                    textAlign="start"
                    fontWeight={800}
                    fontSize={14}
                />
            </button>
            {properties.collapse === properties.sectionName && (
                <RenderChildren menu={properties.menu} />
            )}
        </div>
    )
}

export interface DrawerProperties {
    open?: boolean
    responsive?: boolean
    onClose?: () => void
    commerce: {
        path?: string
        name: string
        code: string
        address: string
        plan: string
    }
    onPay?: () => void
    onHome?: () => void
    onProfile?: () => void
    onChangeLocal?: () => void
    onSuscription?: () => void
    menu: MenuDrawerSectionProperties[]
    onClickEvent?: (navegate: boolean) => void
}

export function DrawerComponent(properties: DrawerProperties) {
    const [collapse, setCollapse] = useState<string>()

    const handlerClick: (func?: () => void) => void = (func) => {
        if (func) {
            func()
        }

        if (properties.onClickEvent) {
            properties.onClickEvent(true)
        }
    }

    const handlerCollapseSection = (
        sectionName: string,
        onNavigate?: () => void
    ) => {
        if (onNavigate) {
            onNavigate()
        } else {
            setCollapse(sectionName)
        }
    }
    console.log('properties.commerce', properties.commerce)

    return (
        <div
            style={{
                ...DrawerStyles.drawer,
                display:
                    properties.responsive && !properties.open ? 'none' : '',
                position: properties.responsive ? 'absolute' : undefined,
            }}
        >
            <div style={DrawerStyles.drawerHeader}>
                <div style={DrawerStyles.drawerHeaderTop}>
                    {properties.commerce.path ? (
                        <img
                            src={properties.commerce.path}
                            alt="logo"
                            style={{
                                width: 100,
                                height: 100,
                                borderRadius: 100,
                            }}
                        />
                    ) : (
                        <img
                            src={amipossWhite}
                            alt="logo"
                            style={{
                                width: 100,
                                height: 100,
                                borderRadius: 100,
                            }}
                        />
                    )}

                    {properties.responsive && (
                        <div>
                            <button
                                onClick={properties.onClose}
                                style={DrawerStyles.drawerHeaderBtn}
                            >
                                <SvgIcon iconName="IconLeftBlue" />
                                <SvgIcon iconName="IconLeftBlue" />
                            </button>
                        </div>
                    )}
                </div>
                <div style={{ marginTop: 10 }}>
                    {properties.commerce.name && (
                        <Text
                            label={getLocalName()}
                            marginBottom={10}
                            fontWeight={600}
                            lineHeight={1}
                            color="#fff"
                        />
                    )}
                    {properties.commerce.address && (
                        <Text
                            label={properties.commerce.address}
                            marginBottom={17}
                            lineHeight={1}
                            fontSize={13}
                            color="#fff"
                        />
                    )}
                    {properties.commerce.code && (
                        <Text
                            label={`Mi código de comercio:  ${properties.commerce.code}`}
                            lineHeight={1.3}
                            fontSize={14}
                            color="#fff"
                        />
                    )}
                    {/* {isLocalView() && (
                        <div
                            style={{
                                height: 20,
                                width: 230,
                                borderRadius: 30,
                                backgroundColor: '#184287',
                                padding: 5,
                                display: 'flex',
                                marginTop: 10,
                                paddingLeft: 20,
                            }}
                        >
                            <Text
                                label={`Suscripción: `}
                                fontSize={14}
                                color="#fff"
                            />
                            <Text
                                label={properties.commerce.plan}
                                fontSize={14}
                                color="#fff"
                                fontWeight={'bold'}
                            />
                        </div>
                    )} */}
                </div>
            </div>
            <div style={DrawerStyles.drawerContent}>
                {isAdmin() && (
                    <button
                        onClick={() => handlerClick(properties.onChangeLocal)}
                        style={DrawerStyles.storeBtn}
                    >
                        <div style={DrawerStyles.homeBtnContent}>
                            <img
                                src={storeBtn}
                                style={DrawerStyles.changeBtnStyle}
                            />
                            <Text
                                fontSize={14}
                                label="Cambiar de local"
                                color="#2699D6"
                                marginLeft={10}
                                fontWeight={800}
                            />
                        </div>
                    </button>
                )}
                {properties.onHome && (
                    <button
                        onClick={() => handlerClick(properties.onHome)}
                        style={DrawerStyles.homeBtn}
                    >
                        <div style={DrawerStyles.homeBtnContent}>
                            <SvgIcon
                                width={22}
                                height={22}
                                iconName="IconHome"
                            />
                            <Text
                                fontSize={14}
                                label="Inicio"
                                color="#656565"
                                marginLeft={10}
                                fontWeight={800}
                            />
                        </div>
                    </button>
                )}
                {isLocalView() && properties.onPay && (
                    <button
                        onClick={() => handlerClick(properties.onPay)}
                        style={DrawerStyles.payBtn}
                    >
                        <Text
                            fontWeight={800}
                            label="COBRAR"
                            fontSize={14}
                            color="#fff"
                        />
                    </button>
                )}
                {properties.menu
                    .filter((item) => !item.hide)
                    .map((item, index) => (
                        <RenderItem
                            key={index}
                            {...item}
                            menu={item.menu}
                            collapse={collapse}
                            onNavigate={item.onNavigate}
                            sectionName={item.sectionName}
                            onClickEvent={item.onClickEvent}
                            onCollapse={handlerCollapseSection}
                        />
                    ))}
                {properties.onSuscription && (
                    <div style={DrawerStyles.suscriptionContainer}>
                        <button
                            onClick={() =>
                                handlerClick(properties.onSuscription)
                            }
                            style={DrawerStyles.suscriptionBtn}
                        >
                            <Text
                                label="Mejora tu plan"
                                fontWeight={400}
                                color="#0086D6"
                                fontSize={14}
                            />
                            <div style={{ marginLeft: 10 }}>
                                <SvgIcon
                                    width={22}
                                    height={22}
                                    iconName="IconPadlock"
                                />
                            </div>
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
